export default __webpack_public_path__ + "static/media/not_alowed.4b715a02.svg";